import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Page from '../../../componentes/plantilla/Page';
import { useContextUsuario } from '../../../contexto/usuario/UsuarioContext';
import { mostraAlertaOk } from '../../../componentes/alerts/sweetAlert';

const ProductoDetalle = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { setCarritoPedidos, setCarritoCotizacion } = useContextUsuario();
    const { producto } = location.state || {};
    const [activeImg, setActiveImg] = useState('');
    const [cantidad, setCantidad] = useState(1);

    useEffect(() => {
        if (!producto) {
            navigate('/app/clientes/productos');
            return;
        }
        if (producto.imagenes && producto.imagenes.length > 0) {
            setActiveImg(producto.imagenes[0]);
        }
    }, [producto, navigate]);

    if (!producto) {
        return null;
    }

    const primerLoteActivo = (producto.lotes || []).find(lote => lote.estado === "Disponible" && lote.existencia > 0);
    const loteIdParaCarrito = primerLoteActivo ? primerLoteActivo.id : null;

    const agregarAlCarrito = () => {
        const imagenPrincipal = producto.imagenes && producto.imagenes.length > 0 ? producto.imagenes[0] : "/productos.jpg";
        const precioProducto = parseFloat(producto.precio) || 0;
        const calculatedPrice = (precioProducto * cantidad).toFixed(2);

        setCarritoPedidos((prevCarrito) => {
            const indiceExistente = prevCarrito.findIndex((item) => item.id === producto.id && item.loteId === loteIdParaCarrito);
            if (indiceExistente !== -1) {
                const carritoActualizado = [...prevCarrito];
                carritoActualizado[indiceExistente].cantidad += cantidad;
                carritoActualizado[indiceExistente].price = (parseFloat(carritoActualizado[indiceExistente].precio) * carritoActualizado[indiceExistente].cantidad).toFixed(2);
                return carritoActualizado;
            } else {
                return [...prevCarrito, { ...producto, cantidad, imagen: imagenPrincipal, price: calculatedPrice, loteId: loteIdParaCarrito }];
            }
        });
        mostraAlertaOk(`${producto.nombre} se ha agregado al carrito`, `Agregado(s) ${cantidad} producto(s)`);
    };

    const agregarAlCarritoCotizacion = (prod) => {
        const imagenPrincipal = prod.imagenes && prod.imagenes.length > 0 ? prod.imagenes[0] : "/productos.jpg";
        const precioProducto = parseFloat(prod.precio) || 0;
        const calculatedPrice = (precioProducto * cantidad).toFixed(2);

        setCarritoCotizacion((prevCarrito) => {
            const existe = prevCarrito.find((item) => item.id === prod.id && item.loteId === loteIdParaCarrito);
            if (existe) {
                return prevCarrito.map((item) =>
                    item.id === prod.id
                        ? { ...item, cantidad: (item.cantidad || 0) + cantidad, price: (parseFloat(item.precio) * ((item.cantidad || 0) + cantidad)).toFixed(2), imagen: imagenPrincipal, loteId: loteIdParaCarrito }
                        : item
                );
            }
            return [...prevCarrito, { ...prod, cantidad, imagen: imagenPrincipal, price: calculatedPrice, loteId: loteIdParaCarrito }];
        });
        mostraAlertaOk(`${prod.nombre} se ha agregado ala cotizacion`, "Producto agregado");
    };

    const handleCantidadChange = (e) => {
        const valor = parseInt(e.target.value, 10);
        if (!isNaN(valor) && valor > 0) {
            setCantidad(valor);
        } else if (e.target.value === '') {
            setCantidad('');
        }
    };

    const listaCaracteristicas = producto.caracteristicas ? producto.caracteristicas.split('\n').filter(car => car.trim() !== '') : [];

    const getStockStatus = (existencia) => {
        if (existencia > 10) {
            return { text: "Existencia", color: "text-success" };
        } else if (existencia > 0) {
            return { text: "Pocas unidades", color: "text-warning" };
        } else {
            return { text: "Agotado", color: "text-danger" };
        }
    };

    const stockStatus = getStockStatus(producto.existencia);

    const datos = {
        titulo: {
            titulo: producto.nombre,
            url: "/app/clientes/productos",
            tituloUrl: "Catálogo",
            nombreUrl: "Detalle del producto",
        },
    };

    let precioMostrado = parseFloat(producto.precio) || 0;

    if (primerLoteActivo) {
        precioMostrado = parseFloat(primerLoteActivo.precio) || precioMostrado;
    }

    return (
        <Page datos={datos}>
            <section className="content">
                <div className="card card-solid">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                                <div className="col-12">
                                    <img src={activeImg} className="product-image" alt="Product Image" style={{ width: '100%', height: 'auto', maxHeight: '500px', objectFit: 'contain' }} />
                                </div>
                                <div className="col-12 product-image-thumbs mt-2 d-flex flex-wrap justify-content-center justify-content-lg-start">
                                    {producto.imagenes.map((img, index) => (
                                        <div
                                            key={index}
                                            className={`product-image-thumb ${activeImg === img ? 'active' : ''} m-1`}
                                            onClick={() => setActiveImg(img)}
                                        >
                                            <img src={img} alt="Product Thumbnail" />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="col-12 col-lg-6">
                                <h3 className="my-3 text-break">{producto.nombre}</h3>
                                <hr />
                                <div className="bg-light py-2 px-3 mt-4 rounded">
                                    <h2 className="mb-0">
                                        L. {precioMostrado.toFixed(2)}
                                    </h2>
                                    <p className="text-muted small mb-0">* ISV Incluido</p>
                                </div>

                                <div className="mt-3">
                                    <h5 className="fw-bold">Disponibilidad:</h5>
                                    <span className={stockStatus.color}>
                                        <i className={`fas fa-circle me-1 mx-2 ${stockStatus.color}`}></i>
                                        {stockStatus.text} ({producto.existencia} unidades)
                                    </span>
                                </div>
                                {producto.productoTipo && producto.productoTipo.nombre && (
                                    <div className="mt-3">
                                        <h5 className="fw-bold">Categoría:</h5>
                                        <span>{producto.productoTipo.nombre}</span>
                                    </div>
                                )}
                                {producto.precioPorMayor === "Activo" && producto.productoprecios && producto.productoprecios.length > 0 && (
                                    <div className="mt-4">
                                        <h5 className="fw-bold">Precios al por Mayor:</h5>
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>Cantidad Mínima</th>
                                                        <th>Precio por Unidad</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {producto.productoprecios.map((pp, idx) => (
                                                        <tr key={idx}>
                                                            <td>{pp.cantidad}</td>
                                                            <td>L. {parseFloat(pp.precio).toFixed(2)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                                {primerLoteActivo && primerLoteActivo.loteprecios && primerLoteActivo.loteprecios.length > 0 && (
                                    <div className="mt-4">
                                        <h5 className="fw-bold">Precios por Cantidad (Lote):</h5>
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-sm">
                                                <thead>
                                                    <tr>
                                                        <th>Cantidad Mínima</th>
                                                        <th>Precio por Unidad</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {primerLoteActivo.loteprecios
                                                        .sort((a, b) => a.cantidad - b.cantidad)
                                                        .map((lp, idx) => (
                                                            <tr key={idx}>
                                                                <td>{lp.cantidad}</td>
                                                                <td>L. {parseFloat(lp.precio).toFixed(2)}</td>
                                                            </tr>
                                                        ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}
                                <div className="mt-4">
                                    <div className='d-flex align-items-center mb-3 flex-wrap'>
                                        <label htmlFor="cantidad" className="me-3 mb-2 mb-sm-0">Cantidad:</label>
                                        <input
                                            id="cantidad"
                                            type="number"
                                            value={cantidad}
                                            onChange={handleCantidadChange}
                                            className="form-control text-center mx-2 border border-primary"
                                            style={{ width: '80px', flexShrink: 0 }}
                                            min="1"
                                        />
                                    </div>
                                    <h5 className="mt-3 fw-bold">Descripción:</h5>
                                    <p>{producto.descripcion || "No hay descripción disponible."}</p>

                                    <div className="d-grid gap-2 d-md-flex justify-content-md-start mt-4">
                                        <button className="btn btn-primary btn-lg btn-flat mx-2" onClick={agregarAlCarrito}>Agregar
                                            <i className="fas fa-cart-plus fa-lg me-2 mx-2"></i>
                                        </button>
                                        <button className="btn btn-info btn-lg btn-flat mx-2" onClick={() => agregarAlCarritoCotizacion(producto)}>Cotizar
                                            <i className="fas fa-file-invoice fa-lg me-2 mx-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <nav className="w-100">
                                <div className="nav nav-tabs" id="product-tab" role="tablist">
                                    <a className="nav-item nav-link active" id="product-features-tab" data-toggle="tab" href="#product-features" role="tab" aria-controls="product-features" aria-selected="true">Características</a>
                                </div>
                            </nav>
                            <div className="tab-content p-3" id="nav-tabContent">
                                <div className="tab-pane fade show active" id="product-features" role="tabpanel" aria-labelledby="product-features-tab">
                                    {listaCaracteristicas.length > 0 ? (
                                        <ul>
                                            {listaCaracteristicas.map((car, index) => (
                                                <li key={index}>{car}</li>
                                            ))}
                                        </ul>
                                    ) : "No hay características adicionales."}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Page>
    );
};

export default ProductoDetalle;